module.exports = __webpack_public_path__ + "img/fi-rr-lock-alt.1b97685e.svg";